import type {
  Action,
  SagaCallbacks,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestDocuments = ({ userId } = {}): Action => ({
  type: actionTypes.REQUEST_DOCUMENTS,
  userId,
});

export const requestGetDocument = ({
  id,
  withAssignees,
  callbacks,
}: {
  id: number,
  withAssignees: boolean,
  callbacks: SagaCallbacks,
} = {}): Action => ({
  type: actionTypes.REQUEST_GET_DOCUMENT,
  id,
  withAssignees,
  callbacks,
});

export const requestAssignDocumentToClient = ({
  id,
  list,
  payload,
} = {}): Action => ({
  type: actionTypes.REQUEST_ASSIGN_DOCUMENT_TO_CLIENT,
  id,
  list,
  payload,
});

export const requestUnAssignDocumentToClient = ({
  id,
  clientId,
  assignmentId,
  callbacks,
}: {} = {}): Action => ({
  type: actionTypes.REQUEST_UNASSIGN_DOCUMENT_TO_CLIENT,
  id,
  clientId,
  assignmentId,
  callbacks,
});

export const requestAssignDocumentToGroup = ({
  id,
  list,
  payload,
} = {}): Action => ({
  type: actionTypes.REQUEST_ASSIGN_DOCUMENT_TO_GROUP,
  id,
  list,
  payload,
});

export const requestUnAssignDocumentToGroup = ({
  id,
  qs,
} = {}): Action => ({
  type: actionTypes.REQUEST_UNASSIGN_DOCUMENT_TO_GROUP,
  id,
  qs,
});
